export default function truncateStringByWords(
  string: string,
  wordLimit: number,
): string {
  const words = string?.split(' ');
  if (words?.length <= wordLimit) return string;

  return `${words?.slice(0, wordLimit).join(' ')}...`;
}
